/**
 * Visitor ID plugin
 * @module
 */

module.exports = function(PluginManager) {
  PluginManager.registerVisitorProfileProvider(require('./provider'));
};
